import * as actionTypes from './actionTypes'
import { v4 as uuid } from 'uuid'
import { fromJS } from 'immutable'
import { processButtonAction } from './processButtonAction'

const ALERT_BOTTOM_MARGIN = 20

export const processLookupAddRec =
  (
    addRecordPage,
    addRecordWidth,
    addRecordHeight,
    addRecordPosition,
    internalRedirectParams = {},
    addRecordCustomPageURL
  ) =>
  (dispatch) => {
    if (addRecordPage === 'ftCustom') {
      return dispatch(
        processButtonAction(
          fromJS([
            {
              uid: uuid(),
              conditions: [],
              isAction: false,
              actions: {
                redirect: [
                  {
                    enabled: true,
                    customURL: addRecordCustomPageURL,
                    target: 'modal',
                    width: addRecordWidth,
                    height: addRecordHeight,
                    positionOfModal: addRecordPosition,
                    internalRedirectParams,
                  },
                ],
              },
            },
          ])
        )
      )
    }
    dispatch(
      processButtonAction(
        fromJS([
          {
            uid: uuid(),
            conditions: [],
            isAction: false,
            actions: {
              redirect: [
                {
                  enabled: true,
                  typeOfRedirect: 'Internal',
                  redirect: { value: addRecordPage, type: 'page', ftMode: 'Internal' },
                  target: 'modal',
                  width: addRecordWidth,
                  height: addRecordHeight,
                  positionOfModal: addRecordPosition,
                  internalRedirectParams,
                },
              ],
            },
          },
        ])
      )
    )
  }

export const getTopModalPosition = (size, uid, index) => {
  try {
    let halfSize = size / 2
    if (window.self !== window.top) {
      let clientY
      try {
        if (window.event && window.event.clientY) {
          clientY = window.event.clientY
        }
      } catch (err) {}

      if (!clientY && uid) {
        try {
          if (index !== null && index !== undefined) {
            uid += '_' + index
          }
          let domElem = document.getElementById(uid)
          if (domElem) {
            let rect = domElem.getBoundingClientRect()
            clientY = rect.top
          }
        } catch (err) {
          console.error(err)
        }
      }

      let localTop = Math.max(halfSize, clientY - halfSize, 0)
      if (localTop + size > window.innerHeight) {
        localTop = window.innerHeight - size
      }
      return Math.max(localTop, 0)
    }
  } catch (err) {}
  return null
}

export const isIframeForceUpdate = (id, ref) => {
  if (window.self !== window.top) {
    let elem = document.getElementById(id)
    if (!elem && ref && typeof ref?.current?.getBoundingClientRect === 'function') {
      elem = ref.current
    }
    return !elem
  } else {
    return false
  }
}

export const getElementTopPosition = (id, clientY, baseStyle = {}, ref, prevTop) => {
  try {
    let elem = document.getElementById(id)
    if (!elem && ref && typeof ref?.current?.getBoundingClientRect === 'function') {
      elem = ref.current
    }
    let size = 50
    if (elem) {
      size = elem.getBoundingClientRect().height
    }
    if (window.self !== window.top) {
      if (prevTop === 0) {
        return {
          ...baseStyle,
          marginTop: 0,
          marginBottom: 0,
          top: 0,
        }
      }
      let windowHeight = window.innerHeight
      let scale = 1
      let isFirefox = navigator.userAgent.indexOf('Firefox') !== -1
      if (!isFirefox && _.get(__FT__APP__STATE.project, ['Settings', 'responsiveAIConf', 'isAutoScale'], false)) {
        let appState = __FT_PROJECT__API__.FTSyncState()
        let defVal = appState.getIn(['project', 'Settings', 'theme', 'lg', 'Page', 'root', 'width'], 1367)
        let pageWidth = appState.getIn(
          ['project', 'Settings', 'theme', 'lg', 'Page', appState.get('page'), 'width'],
          defVal
        )
        const windowWidth = window.document?.documentElement?.clientWidth || window.innerWidth
        const width = parseInt(pageWidth, 10)
        scale = parseFloat(windowWidth / width) - 0.05
      }
      if (scale !== 1) {
        windowHeight = Math.min(document.body.clientHeight, window.innerHeight)
      }
      let localTop = clientY
      if (localTop + size > windowHeight) {
        localTop = ~~(windowHeight - size - ALERT_BOTTOM_MARGIN)
      }
      return {
        ...baseStyle,
        marginTop: 0,
        marginBottom: 0,
        top: ~~Math.max(localTop, 0),
      }
    }
  } catch (err) {
    // console.error(err)
  }
  return {}
}

export const lookupFieldOpenModal =
  (component, pageUID, uid, statePath, repeatIndex, isRepeat, rulePath) => (dispatch, getAllState) => {
    dispatch({
      type: actionTypes.OPEN_LOOKUP_MODAL,
      payload: {
        component,
        pageUID,
        uid,
        statePath,
        repeatIndex,
        isRepeat,
        rulePath,
        top: getTopModalPosition(700),
      },
    })
  }

export const dateRangeFieldOpenModal =
  (component, pageUID, uid, statePath, repeatIndex, isRepeat, rulePath) => (dispatch, getAllState) => {
    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: getAllState().setIn(
          ['ftModals', 'daterange'],
          fromJS({
            open: !component.get('doNotOpenModal', false),
            component,
            pageUID,
            uid,
            statePath,
            repeatIndex,
            isRepeat,
            rulePath,
            top: getTopModalPosition(700),
          })
        ),
      },
    })
  }
